import { VIEW_MANAGEMENT } from 'store/types';

function showHomePagePreloader() {
  return {
    type: VIEW_MANAGEMENT.SHOW_HOME_PAGE_PRELOADER,
  };
}

export default showHomePagePreloader;
